
import { css } from 'lit';
export default css`
:host{
  --pc-menu-sm-rigth-gap:calc((100vw - 926px) / 2);
  --pc-menu-md-rigth-gap:calc((100vw - 1024px) / 2);
  --pc-menu-lg-rigth-gap:calc((100vw - 1152px) / 2);
  --pc-menu-xl-rigth-gap:calc((100vw - 1280px) / 2);
  --pc-menu-2xl-rigth-gap:calc((100vw - 1440px) / 2);

  --pc-menu-sm-content-width:960px;
  --pc-menu-md-content-width:960px;
  --pc-menu-lg-content-width:960px;
  --pc-menu-xl-content-width:1002px;
  --pc-menu-2xl-content-width:1270px;

  display:contents;
}

.trigger-button{
  display:flex;
  justify-content:space-between;
  align-items:center;
  cursor:pointer;
  border:none;
  border-bottom:1px solid var(--purple-medium-neutral);
  background-color:var(--primary-white);
  padding:var(--spacing-5) var(--spacing-8);
  width:100%;
  font-weight:500;
  font-size:var(--fs-body-mobile);
  font-family:var(--ff-body);
  text-align:left;
}

.trigger-button:hover,
.trigger-button:focus,
.trigger-button pc-icon[name='chevron-right']{
  color:var(--purple-indigo);
}

.trigger-button pc-icon[name='chevron-down']{
  display:none;
}

.back-button{
  display:inline-flex;
  align-items:center;
  gap:var(--spacing-3);
  transition:background-size 0.3s;
  cursor:pointer;
  border:none;
  background-image:linear-gradient(
    transparent calc(100% - 2px),
    var(--purple-indigo) 2px
  );
  background-size:0 100%;
  background-repeat:no-repeat;
  background-color:transparent;
  background-position-x:24px;
  padding:0 0 4px 0;
  font-weight:var(--fw-medium);
  font-size:var(--fs-eyebrow-mobile);
  font-family:var(--ff-body);
  letter-spacing:var(--ls-eyebrow);
  text-transform:uppercase;
}

.back-button:hover,
.back-button:focus{
  background-size:100% 100%;
  color:var(--purple-indigo);
}

.back-button pc-icon{
  color:var(--purple-indigo);
}

.close-button{
  display:none;
}

.content{
  display:none;
  position:absolute;
  top:0;
  right:0;
  left:0;
  flex-direction:column;
  box-shadow:0px 4px 4px 0px rgba(91, 73, 108, 0.2);
  border-radius:0px 0px var(--spacing-4) var(--spacing-4);
  background-color:var(--primary-white);
}

:host([is-expanded]) .dropdown .content{
  display:flex;
}

.heading{
  display:flex;
  flex-direction:column;
  align-items:flex-start;
  gap:var(--spacing-6);
  border-bottom:1px solid var(--purple-medium-neutral);
  padding:var(--spacing-6) var(--spacing-8);
}

::slotted([slot='primary']){
  display:flex;
  flex-direction:column;
}

::slotted([slot='ancillary']){
  display:flex;
  flex-direction:column;
  border-radius:0px 0px var(--spacing-4) var(--spacing-4);
  background-color:var(--neutral-light);
  padding:var(--spacing-4) var(--spacing-8) var(--spacing-6);
}

@media (min-width: 768px){
  .content,
  ::slotted([slot='ancillary']){
    border-radius:0px 0px 0 var(--spacing-4);
  }
}

@media (min-width: 992px){
  .trigger-button{
    --button-border-color:var(--purple-indigo);

    justify-content:inherit;
    gap:6px;
    transition:background-size 0.3s;
    margin:var(--spacing-4) 0;
    border-bottom:none;
    background-image:linear-gradient(
      transparent calc(100% - 2px),
      var(--button-border-color) 2px
    );
    width:-moz-fit-content;
    width:fit-content;
    background-size:0 100%;
    background-repeat:no-repeat;
    padding:0 0 4px 0;
    font-size:var(--fs-body);
    line-height:var(--lh-body);
  }

  .trigger-button:hover,
  .trigger-button:focus{
    background-size:calc(100% - 28px) 100%;
  }

  .dropdown.level-1 .trigger-button{
    --button-border-color:var(--purple-indigo-light);
    margin:0;
    background-color:transparent;
    color:var(--primary-white);
  }

  .dropdown.level-1 .trigger-button:hover,
  .dropdown.level-1 .trigger-button:focus,
  :host([is-expanded]) .dropdown.level-1 .trigger-button{
    background-size:100% 100%;
  }

  :host([is-expanded])
    .dropdown.level-1
    .trigger-button
    pc-icon[name='chevron-down']{
    transform:rotate(180deg);
  }

  .trigger-button pc-icon[name='chevron-down']{
    display:inherit;
  }

  .dropdown.level-1 .trigger-button pc-icon[name='chevron-right']{
    display:none;
  }

  .dropdown:not(.level-1) .trigger-button{
    gap:var(--spacing-3);
  }

  .dropdown:not(.level-1) .trigger-button pc-icon[name='chevron-down']{
    display:none;
  }

  .close-button{
    display:block;
    position:absolute;
    top:var(--spacing-10);
    right:var(--pc-menu-sm-rigth-gap);
    cursor:pointer;
    border:none;
    background:none;
  }

  .close-button pc-icon{
    color:var(--purple-indigo);
  }

  .back-button{
    background-position-x:28px;
    font-size:var(--fs-eyebrow);
  }

  .dropdown.level-1 .back-button{
    display:none;
  }

  .content{
    border-radius:0px 0px 0px 32px;
  }

  .dropdown.level-1 .content{
    top:148px;
    left:auto;
    padding-top:0;
    width:var(--pc-menu-sm-content-width);
  }

  .heading{
    margin-bottom:var(--spacing-6);
    border-bottom:none;
    padding:0;
  }

  .primary-section{
    flex-shrink:0;
    padding-top:var(--spacing-8);
    padding-bottom:var(--spacing-16);
    padding-left:var(--spacing-20);
    width:40%;
  }

  .content:not(.has-ancillary) .primary-section{
    flex:1;
    padding-right:var(--pc-menu-sm-rigth-gap);
    width:auto;
  }

  .content.has-ancillary{
    flex-direction:row;
  }

  .content.has-ancillary .ancillary-section{
    width:100%;
  }

  ::slotted([slot='primary']){
    display:grid;
    grid-template-columns:repeat(auto-fit, minmax(315px, 1fr));
    column-gap:3%;
  }

  ::slotted([slot='ancillary']){
    border-radius:0;
    padding-top:var(--spacing-28);
    padding-right:var(--pc-menu-sm-rigth-gap);
    padding-bottom:var(--spacing-16);
    height:100%;
  }
}

@media (min-width: 1152px){
  .dropdown.level-1 .content{
    width:var(--pc-menu-md-content-width);
  }

  .content:not(.has-ancillary) .primary-section,
  ::slotted([slot='ancillary']){
    padding-right:var(--pc-menu-md-rigth-gap);
  }

  .close-button{
    right:var(--pc-menu-md-rigth-gap);
  }
}

@media (min-width: 1280px){
  .dropdown.level-1 .content{
    width:var(--pc-menu-lg-content-width);
  }

  .content:not(.has-ancillary) .primary-section,
  ::slotted([slot='ancillary']){
    padding-right:var(--pc-menu-lg-rigth-gap);
  }

  .close-button{
    right:var(--pc-menu-lg-rigth-gap);
  }
}

@media (min-width: 1440px){
  .dropdown.level-1 .content{
    width:var(--pc-menu-xl-content-width);
  }

  .content:not(.has-ancillary) .primary-section,
  ::slotted([slot='ancillary']){
    padding-right:var(--pc-menu-xl-rigth-gap);
  }

  .close-button{
    right:var(--pc-menu-xl-rigth-gap);
  }
}

@media (min-width: 1536px){
  .dropdown.level-1 .content{
    width:var(--pc-menu-2xl-content-width);
  }

  .content:not(.has-ancillary) .primary-section,
  ::slotted([slot='ancillary']){
    padding-right:var(--pc-menu-2xl-rigth-gap);
  }

  .close-button{
    right:var(--pc-menu-2xl-rigth-gap);
  }
}
`;